import { SupportedLanguage } from '@demind-inc/core';

export const DAYJS_LOCALE_BY_LANGUAGE: Record<SupportedLanguage, string> = {
  en: 'en',
  it: 'it',
  ko: 'ko',
  el: 'el',
  ja: 'ja',
  fr: 'fr',
  de: 'de',
  es: 'es',
  pt: 'pt',
  'zh-Hans': 'zh-cn',
};

export const getDayjsLocaleForLanguage = (language: SupportedLanguage) =>
  DAYJS_LOCALE_BY_LANGUAGE[language];
